import {useTranslation} from 'react-i18next';

import {useIsWorkspaceAvailable} from '@lib/logic';
import {LocalDateString, OfficeWorkday} from '@lib/store/src/data/timeslots/apiTypes';
import {WarningIndicator} from '../WarningIndicator';

interface Props {
  workday?: OfficeWorkday;
  workspace: {
    buildingId?: string;
    floorId?: string;
    areaId?: string;
  };
  localStart: LocalDateString;
  localEnd: LocalDateString;

  isEditing?: boolean;
}

/**
 * Checks if the provided workspace is available for the given workday and time range.
 * If unavailable, renders a warning indicator to inform the user.
 */
export const WorkspaceAvailabilityWarning = ({workday, workspace, localStart, localEnd, isEditing}: Props) => {
  const {t} = useTranslation();
  const {isWorkspaceAvailable, isPendingWorkspaceAvailability, isWorkspaceAvailabilityResolved} =
    useIsWorkspaceAvailable({
      workday,
      workspace,
      localStart,
      localEnd,
      isEditing,
    });

  if (isPendingWorkspaceAvailability || !isWorkspaceAvailabilityResolved || isWorkspaceAvailable || !workspace) {
    return null;
  }

  return (
    <div className="px-6 bg-white">
      <WarningIndicator message={t('timeslots:OfficeIsBusy')} />
    </div>
  );
};
